var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2510_2295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.712,
    height: 18.207,
    rx: 8.856,
    transform: "matrix(4.49329e-08 -1 -1 -4.25231e-08 18.207 17.712)",
    fill: "#20315F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62603 8.85666L11.0382 5.50937C11.2907 5.2613 11.2907 4.86122 11.0382 4.61315C10.9178 4.49465 10.7537 4.428 10.5825 4.428C10.4113 4.428 10.2471 4.49465 10.1268 4.61315L6.259 8.40789C6.00565 8.65568 6.00565 9.05631 6.259 9.3041L10.1267 13.0988C10.2471 13.2173 10.4113 13.284 10.5825 13.284C10.7537 13.284 10.9178 13.2173 11.0383 13.0988C11.2907 12.8507 11.2907 12.4507 11.038 12.2026L7.62603 8.85666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2510_2295",
    x: -136.98,
    y: -136.98,
    width: 292.167,
    height: 291.672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 68.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2510_2295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2510_2295",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.e175077be2d01002b582d74da5b0d9db.svg";
export { ForwardRef as ReactComponent };